module.exports = __webpack_public_path__ + "static/media/instaperfect_brand_banner.0c043c2c.jpg";